// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rbc-current-time-indicator {
  height: 3px;
}

.rdp-month_grid {
  background-color: #f8f9fa;
}

.rbc-time-header-gutter {
  width: 51px;
  border-bottom: 1px solid #ddd;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #e6e6e6;
}

.rbc-time-slot {
  display: flex;
  align-items: center;
}

.rbc-timeslot-group {
  min-height: 30px !important;
}

.rbc-allday-cell {
  display: none;
}

.rbc-time-content {
  border-top: 0px;
}

.rbc-header {
  font-weight: normal;
}

.rbc-event {
  border-radius: 0.375rem;
}

.rbc-event:focus {
  background-color: #172228;
}

.rbc-day-slot .rbc-event-content {
  font-size: 90%;
}

.rbc-time-header-content > .rbc-row.rbc-row-resource {
  background-color: #172228;
  color: #fff;
}

.rdp-caption_label {
  text-transform: capitalize;
}

.rdp-today:not(.rdp-outside) {
  background-color: #d8b8a1;  
  color: #000;
}

.rdp-selected {
  font-weight: normal;
  color: #fff;
  font-size: medium;
  background-color: #172228;
}

.rdp-selected .rdp-day_button {
  border: none;
}

.rbc-day-slot .rbc-events-container {
  margin-right: 0px;
}

.rdp-chevron {
  display: inline-block;
  fill: #172228;
}

.rbc-time-header-content > .rbc-row.rbc-row-resource {
  border-bottom: none !important;
}

.css-13cymwt-control:focus {
  border: none;
}

.css-1dimb5e-singleValue {
  color: #000 !important;
}

.css-t3ipsp-control:hover, .css-t3ipsp-control:focus {
  border-color: #31414b !important;
  box-shadow: 0 0 0 .25rem rgba(23, 34, 40, .50);
}

.colaborador-width {
  width: 300px;
}

.status-button {
  display: flex;
  align-items: start;
  justify-content: center;
  padding: 10px 16px;
  border-radius: 8px;
  color: white;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}

.bg-agendado { 
  background-color: #078678B3; 
  color: white; 
  border: 2px solid #036d61  
}

.bg-cancelado { 
  background-color: #bababa; 
  color: #222; 
  border: 2px solid #9b9b9b;  
}

.bg-confirmado { 
  background-color: #17a2b8B3; 
  color: #222; 
  border: 2px solid #17a2b8;  
}

.bg-aguardando { 
  background-color: #ffc107B3; 
  color: #222; 
  border: 2px solid #ffc107;  
}

.bg-finalizado { 
  background-color: #0056b3B3; 
  color: white; 
  border: 2px solid #0056b3;  
}

.bg-em-atendimento { 
  background-color: #28a745B3; 
  color: white; 
  border: 2px solid #28a745; 
}

.bg-pago { 
  background-color: #ff8c69B3; 
  color: white; 
  border: 2px solid #ff8c69;  
}

.bg-faltou { 
  background-color: #6c757dB3; 
  color: white; 
  border: 2px solid #6c757d;  
}

.status-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  filter: grayscale(50%);
  pointer-events: none;
}

.status-button.selected {
  transform: scale(1.05);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}

/* Responsividade apenas para mobile - não altera desktop */
@media (max-width: 997px) {
  .status-grid-mobile {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 10px !important;
  }

  .status-grid-mobile .status-button {
    font-size: 14px;
  }

  .status-grid-mobile .form-check {
    padding-left: 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/agendamento.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA,2DAA2D;AAC3D;EACE;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".rbc-current-time-indicator {\n  height: 3px;\n}\n\n.rdp-month_grid {\n  background-color: #f8f9fa;\n}\n\n.rbc-time-header-gutter {\n  width: 51px;\n  border-bottom: 1px solid #ddd;\n}\n\n.rbc-timeslot-group {\n  border-bottom: 1px solid #e6e6e6;\n}\n\n.rbc-time-slot {\n  display: flex;\n  align-items: center;\n}\n\n.rbc-timeslot-group {\n  min-height: 30px !important;\n}\n\n.rbc-allday-cell {\n  display: none;\n}\n\n.rbc-time-content {\n  border-top: 0px;\n}\n\n.rbc-header {\n  font-weight: normal;\n}\n\n.rbc-event {\n  border-radius: 0.375rem;\n}\n\n.rbc-event:focus {\n  background-color: #172228;\n}\n\n.rbc-day-slot .rbc-event-content {\n  font-size: 90%;\n}\n\n.rbc-time-header-content > .rbc-row.rbc-row-resource {\n  background-color: #172228;\n  color: #fff;\n}\n\n.rdp-caption_label {\n  text-transform: capitalize;\n}\n\n.rdp-today:not(.rdp-outside) {\n  background-color: #d8b8a1;  \n  color: #000;\n}\n\n.rdp-selected {\n  font-weight: normal;\n  color: #fff;\n  font-size: medium;\n  background-color: #172228;\n}\n\n.rdp-selected .rdp-day_button {\n  border: none;\n}\n\n.rbc-day-slot .rbc-events-container {\n  margin-right: 0px;\n}\n\n.rdp-chevron {\n  display: inline-block;\n  fill: #172228;\n}\n\n.rbc-time-header-content > .rbc-row.rbc-row-resource {\n  border-bottom: none !important;\n}\n\n.css-13cymwt-control:focus {\n  border: none;\n}\n\n.css-1dimb5e-singleValue {\n  color: #000 !important;\n}\n\n.css-t3ipsp-control:hover, .css-t3ipsp-control:focus {\n  border-color: #31414b !important;\n  box-shadow: 0 0 0 .25rem rgba(23, 34, 40, .50);\n}\n\n.colaborador-width {\n  width: 300px;\n}\n\n.status-button {\n  display: flex;\n  align-items: start;\n  justify-content: center;\n  padding: 10px 16px;\n  border-radius: 8px;\n  color: white;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.bg-agendado { \n  background-color: #078678B3; \n  color: white; \n  border: 2px solid #036d61  \n}\n\n.bg-cancelado { \n  background-color: #bababa; \n  color: #222; \n  border: 2px solid #9b9b9b;  \n}\n\n.bg-confirmado { \n  background-color: #17a2b8B3; \n  color: #222; \n  border: 2px solid #17a2b8;  \n}\n\n.bg-aguardando { \n  background-color: #ffc107B3; \n  color: #222; \n  border: 2px solid #ffc107;  \n}\n\n.bg-finalizado { \n  background-color: #0056b3B3; \n  color: white; \n  border: 2px solid #0056b3;  \n}\n\n.bg-em-atendimento { \n  background-color: #28a745B3; \n  color: white; \n  border: 2px solid #28a745; \n}\n\n.bg-pago { \n  background-color: #ff8c69B3; \n  color: white; \n  border: 2px solid #ff8c69;  \n}\n\n.bg-faltou { \n  background-color: #6c757dB3; \n  color: white; \n  border: 2px solid #6c757d;  \n}\n\n.status-button.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  filter: grayscale(50%);\n  pointer-events: none;\n}\n\n.status-button.selected {\n  transform: scale(1.05);\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\n}\n\n/* Responsividade apenas para mobile - não altera desktop */\n@media (max-width: 997px) {\n  .status-grid-mobile {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 10px !important;\n  }\n\n  .status-grid-mobile .status-button {\n    font-size: 14px;\n  }\n\n  .status-grid-mobile .form-check {\n    padding-left: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
